"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _qs = _interopRequireDefault(require("qs"));

var _LoadingOverlay = _interopRequireDefault(require("../LoadingOverlay"));

var _lodash = _interopRequireDefault(require("lodash"));

var _AppTableFilter = _interopRequireDefault(require("./AppTableFilter"));

var _AppTableHead = _interopRequireDefault(require("./AppTableHead"));

var _AppTablePagination = _interopRequireDefault(require("./AppTablePagination"));

var _index = require("../../../index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppTable = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTable, _React$Component);
  /**
   * Constructor
   *
   * @param {Object} props
   */


  function AppTable(props) {
    var _this;

    _classCallCheck(this, AppTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AppTable).call(this, props)); // Initial state

    _this.state = {
      items: [],
      filter: _this._getInitialFilter(props),
      order: _this._getInitialOrder(props),
      pagination: {
        page: _this._getInitialPage(props),
        total_pages: 0,
        limit: 20,
        total_items: 0
      },
      loadedTimes: 0
    };
    props.onInit(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AppTable, [{
    key: "getFilter",
    value: function getFilter() {
      return this.state.filter;
    }
  }, {
    key: "_getInitialFilter",
    value: function _getInitialFilter(props) {
      if (props.location.query.filter) {
        return this._joinFilters(props.filter, props.location.query.filter);
      }

      return props.filter;
    }
  }, {
    key: "_joinFilters",
    value: function _joinFilters(filter, otherFilters) {
      var mainFilter = _toConsumableArray(filter);

      otherFilters.forEach(function (otherFilter) {
        var existingFilter = mainFilter.find(function (x) {
          return x.name == otherFilter.name;
        });

        if (existingFilter) {
          var indexOf = mainFilter.indexOf(existingFilter);
          mainFilter[indexOf] = otherFilter; // mainFilter[indexOf] = {...existingFilter, ...otherFilter};
        } else {
          mainFilter.push(otherFilter);
        }
      });
      return mainFilter;
    }
  }, {
    key: "_getInitialOrder",
    value: function _getInitialOrder(props) {
      if (props.location.query.order) {
        return props.location.query.order;
      }

      return props.order || [];
    }
    /**
     * Called on mount
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._loadItems();
    }
    /**
     * Loading off
     */

  }, {
    key: "_loadingOn",
    value: function _loadingOn() {
      this.setState({
        loading: true
      });
    }
    /**
     * Loading on
     */

  }, {
    key: "_loadingOff",
    value: function _loadingOff() {
      this.setState({
        loading: false
      });
    }
    /**
     * Get initial page
     *
     * @param {Object} props Passed props
     */

  }, {
    key: "_getInitialPage",
    value: function _getInitialPage(props) {
      if (!props.parseUrl) return 1;
      return props.location.query.page ? props.location.query.page : 1;
    }
    /**
     * Get model
     */

  }, {
    key: "_getModel",
    value: function _getModel() {
      if (this.model) return this.model;
      this.model = new this.props.model();
      return this.model;
    }
    /**
     * Load items
     */

  }, {
    key: "_loadItems",
    value: function () {
      var _loadItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var silent,
            listParams,
            results,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                silent = _args.length > 0 && _args[0] !== undefined ? _args[0] : false; // Show loader

                if (!silent) {
                  this._loadingOn();
                }

                _context.prev = 2;
                listParams = this._getListParams();
                _context.next = 6;
                return this._getModel().fetch(listParams);

              case 6:
                results = _context.sent;
                this.setState({
                  loadedTimes: ++this.state.loadedTimes,
                  items: results.items,
                  pagination: results.pagination
                }, function () {
                  _this2._onLoaded();
                });
                _context.next = 12;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);

              case 12:
                setTimeout(function () {
                  _this2._loadingOff();
                }, 100);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 10]]);
      }));

      function _loadItems() {
        return _loadItems2.apply(this, arguments);
      }

      return _loadItems;
    }()
  }, {
    key: "_onLoaded",
    value: function _onLoaded() {
      this.props.onLoad(this.state);
    }
  }, {
    key: "_refresh",
    value: function () {
      var _refresh2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var force,
            silent,
            pageUrl,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
                silent = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;

                if (force && this.props.parseUrl) {
                  pageUrl = '?' + _qs["default"].stringify(_objectSpread({}, this.props.location.query, {
                    page: this.state.pagination.page,
                    filter: this.state.filter.filter(function (x) {
                      return x.value && x.value != '';
                    }),
                    order: this.state.order
                  }));
                  window.history.pushState('', '', pageUrl);

                  this._loadItems(silent); // history.push({
                  //   search: qs.stringify({
                  //     ...this.props.location.query,
                  //     page: this.state.pagination.page,
                  //     filter: this.state.filter,
                  //     order: this.state.order
                  //   })
                  // })

                } else {
                  window.scrollTo(0, 0);

                  this._loadItems(silent);
                }

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _refresh() {
        return _refresh2.apply(this, arguments);
      }

      return _refresh;
    }()
  }, {
    key: "_getListParams",
    value: function _getListParams() {
      var additionalParams = {};

      if (this.state.filter) {
        additionalParams.filter = this.state.filter; // additionalParams.filter = this.state.filter.filter(x => x.value && (x.value + "".length > 0));
      }

      if (this.state.order) {
        additionalParams.order = this.state.order;
      }

      return _objectSpread({
        offset: (this.state.pagination.page - 1) * this.state.pagination.limit,
        limit: this.state.pagination.limit
      }, additionalParams, {}, this.props.params);
    }
    /**
     * Called on page changed
     *
     * @param {Integer} pageNumber New page number
     */

  }, {
    key: "_pageChanged",
    value: function _pageChanged(pageNumber) {
      var _this3 = this;

      var pagination = _objectSpread({}, this.state.pagination);

      pagination.page = pageNumber;
      this.setState({
        pagination: pagination
      }, function () {
        _this3._refresh();
      });
    }
    /**
     * Get rows
     */

  }, {
    key: "_getRows",
    value: function _getRows() {
      var _this4 = this;

      var columns = this._getColumns();

      if (this.state.loadedTimes > 0 && this.state.items.length == 0) {
        return _react["default"].createElement("tr", {
          className: 'app-table-tr ' + this.props.getRowClass()
        }, _react["default"].createElement("td", {
          colSpan: columns.length
        }, "No records"));
      }

      if (this.state.loadedTimes == 0 && this.state.loading) {
        return _react["default"].createElement("tr", {
          className: 'app-table-tr ' + this.props.getRowClass()
        }, _react["default"].createElement("td", {
          colSpan: columns.length
        }, _react["default"].createElement(_LoadingOverlay["default"], null)));
      }

      var elements = [];
      this.state.items.forEach(function (item, index) {
        var innerCells = [];
        columns.forEach(function (column) {
          innerCells.push(_this4._renderCell(column, item, index));
        });
        elements.push(_react["default"].createElement("tr", {
          key: 'tr' + index,
          className: 'app-table-tr ' + _this4.props.getRowClass(item, index)
        }, innerCells));
      });
      return elements;
    }
    /**
     * Render single cell
     *
     * @param {Object} column Column which cell is rendered
     * @param {Object} item
     * @param {Integer} index
     */

  }, {
    key: "_renderCell",
    value: function _renderCell(column, item, index) {
      if (column.type == 'actions') {
        return this._renderActionsCell(item, index);
      } // Extract


      var cellContent = _lodash["default"].get(item, column.name);

      var overridenContent = this.props.renderCell(column, item, index);

      if (overridenContent || overridenContent === null) {
        cellContent = overridenContent;
      }

      return _react["default"].createElement("td", {
        key: column.name + index,
        className: 'app-table-td ' + this.props.getCellClass(column, item, index)
      }, cellContent);
    }
    /**
     * Render actions cell
     * @param column
     * @param item
     * @param index
     */

  }, {
    key: "_renderActionsCell",
    value: function _renderActionsCell(item, index) {
      var actions = this.props.getColumnActions(item, index);
      return _react["default"].createElement("td", {
        key: 'td' + index,
        className: 'app-table-td ' + this.props.getCellClass(null, item, index),
        align: "right"
      }, actions);
    }
    /**
     * Get table header
     */

  }, {
    key: "_getTableHeader",
    value: function _getTableHeader() {
      var _this5 = this;

      return _react["default"].createElement(_AppTableHead["default"], {
        columns: this._getColumns(),
        order: this.state.order,
        onOrder: function onOrder(order) {
          _this5.setState({
            order: order
          }, function () {
            _this5._refresh();
          });
        }
      });
    }
    /**
     * Get columns for table
     */

  }, {
    key: "_getColumns",
    value: function _getColumns() {
      var columns = this._getModel().getTableColumns();

      var overridenColumns = this.props.getTableColumns();
      if (overridenColumns.length) columns = overridenColumns;
      return columns;
    }
  }, {
    key: "_filter",
    value: function _filter(filter) {
      var _this6 = this;

      this.setState({
        filter: this._joinFilters(this.state.filter, filter),
        pagination: _objectSpread({}, this.state.pagination, {
          page: 1
        })
      }, function () {
        _this6._refresh();
      });
    }
  }, {
    key: "_getTableTitle",
    value: function _getTableTitle() {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          headerActions = _this$props.headerActions;

      if (!title) {
        return null;
      }

      var iconElement = _react["default"].createElement(_index.AppIcon, {
        name: icon
      });

      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, iconElement, " ", title), _react["default"].createElement("div", {
        className: "header-actions"
      }, typeof headerActions == 'function' ? headerActions() : headerActions)));
    }
  }, {
    key: "_getLoadingElement",
    value: function _getLoadingElement() {
      if (!this.state.loading || this.state.loadedTimes === 0) return null;
      return _react["default"].createElement(_LoadingOverlay["default"], null);
    }
    /**
     * Render the component
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var tableHeader = this._getTableHeader();

      var rows = this._getRows();

      var title = this._getTableTitle();

      var loadingElement = this._getLoadingElement();

      return _react["default"].createElement("div", {
        className: "element-with-blur"
      }, title, loadingElement, _react["default"].createElement("div", {
        className: "box-body"
      }, _react["default"].createElement(_AppTableFilter["default"], _extends({}, _objectSpread({}, this.props, {
        onInit: function onInit() {}
      }), {
        onFilter: function onFilter(filter) {
          return _this7._filter(filter);
        },
        padded: true
      })), _react["default"].createElement("table", {
        className: "table"
      }, _react["default"].createElement("tbody", null, tableHeader, rows)), _react["default"].createElement("div", {
        className: "clear"
      }), _react["default"].createElement(_AppTablePagination["default"], {
        paginate: this.props.paginate,
        pagination: this.state.pagination,
        onPageChanged: function onPageChanged(page) {
          return _this7._pageChanged(page);
        }
      })));
    }
  }]);

  return AppTable;
}(_react["default"].Component); // Default props


AppTable.defaultProps = {
  onInit: function onInit() {},
  onLoad: function onLoad() {},
  getTableColumns: function getTableColumns() {
    return [];
  },
  getColumnActions: function getColumnActions() {
    return [];
  },
  getCellClass: function getCellClass() {
    return [];
  },
  getRowClass: function getRowClass() {
    return [];
  },
  renderCell: function renderCell() {
    return false;
  },
  params: {},
  parseUrl: true,
  paginate: true,
  filter: []
};

var _default = (0, _reactRouter.withRouter)(AppTable);

exports["default"] = _default;